import "@fontsource-variable/inter"
import "@fontsource-variable/space-grotesk"
import "@fontsource/space-mono/400.css"
import "@fontsource/space-mono/700.css"
import "prismjs/themes/prism-tomorrow.css"
import "./src/styles.css"

export const onRouteUpdate = ({ location }) => {
  if (!location.hash) return

  setTimeout(() => {
    // The hash is user-controlled, so look it up by id rather than as a selector
    let id = location.hash.slice(1)
    try {
      id = decodeURIComponent(id)
    } catch (e) {
      // keep the raw hash
    }
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: "smooth" })
    }
  }, 500)
}
